import { createFileRoute } from '@tanstack/react-router'
import EvidenceCreatingPage from '@/pages/(protected)/workspaces/[workspaceId]/evidence/creating'

type EvidenceCreatingSearch = {
  flowId?: string
}

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/evidence_/creating'
)({
  component: EvidenceCreatingPage,
  validateSearch: (search: Record<string, unknown>): EvidenceCreatingSearch => ({
    flowId: search.flowId as string | undefined,
  }),
})
